<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Label from 'dashboard/components-next/label/Label.vue';

const props = defineProps({
  title: { type: String, default: '' },
  audienceConfig: { type: Object, required: true },
  estimatedCount: { type: [Number, null], default: null },
  template: { type: Object, default: null },
  renderedTemplate: { type: String, default: '' },
  schedule: { type: Object, required: true },
});

const { t } = useI18n();

const audienceSummary = computed(() => {
  switch (props.audienceConfig.mode) {
    case 'all_contacts':
      return t('CAMPAIGN.WHATSAPP.WIZARD.AUDIENCE.MODES.ALL_CONTACTS.LABEL');
    case 'labels':
      return `${t('CAMPAIGN.WHATSAPP.WIZARD.AUDIENCE.MODES.LABELS.LABEL')}: ${(props.audienceConfig.label_titles || []).join(', ')}`;
    case 'labels_include_exclude': {
      const include = (props.audienceConfig.include_label_titles || []).join(
        ', '
      );
      const exclude = (props.audienceConfig.exclude_label_titles || []).join(
        ', '
      );
      return exclude
        ? `${include} (${t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.EXCLUDING')}: ${exclude})`
        : include;
    }
    case 'custom_filter':
      return t('CAMPAIGN.WHATSAPP.WIZARD.AUDIENCE.MODES.CUSTOM_FILTER.LABEL');
    default:
      return '';
  }
});
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-n-slate-11">
      {{ t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.STEP_LABEL') }}
    </p>

    <div class="flex flex-col gap-3 p-4 text-sm rounded-lg bg-n-slate-2">
      <div>
        <strong>{{ t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.TITLE_LABEL') }}</strong>
        {{ title }}
      </div>
      <div>
        <strong>{{
          t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.AUDIENCE_LABEL')
        }}</strong>
        {{ audienceSummary }}
        <span v-if="estimatedCount !== null" class="text-n-slate-11">
          ({{
            t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.RECIPIENT_COUNT', {
              count: estimatedCount,
            })
          }})
        </span>
      </div>
      <div>
        <strong>{{
          t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.TEMPLATE_LABEL')
        }}</strong>
        {{ template?.name }} ({{ template?.language }})
        <Label
          :label="template?.status"
          color="teal"
          compact
          class="capitalize"
        />
      </div>
      <div>
        <strong>{{
          t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.PREVIEW_LABEL')
        }}</strong>
        <p class="mt-1 whitespace-pre-wrap text-n-slate-12">
          {{ renderedTemplate }}
        </p>
      </div>
      <div>
        <strong>{{ t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.WHEN_LABEL') }}</strong>
        {{
          schedule.sendMode === 'now'
            ? t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.SEND_NOW_LABEL')
            : schedule.scheduledAt
        }}
      </div>
    </div>

    <p class="text-xs text-n-slate-11">
      {{ t('CAMPAIGN.WHATSAPP.WIZARD.REVIEW.STATUS_DISCLAIMER') }}
    </p>
  </div>
</template>
